import { withStyles } from '@material-ui/core';
import Logo from 'components/common/Logo';
import { BLOCKS_SPACING, LOGO_HEIGHT, MOBILE_BREAKPOINT } from 'components/pages/BrandedFormPage';
import React from 'react';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
  root: {
    display: 'none',
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      display: 'block',
    },
    paddingBottom: theme.spacing(BLOCKS_SPACING),
  },
  logo: {
    display: 'inline-block',
    height: LOGO_HEIGHT,
  },
});

function MobileLogo({ classes }) {
  return (
    <div className={classes.root}>
      <Link to="/" aria-label="Home page">
        <Logo className={classes.logo} />
      </Link>
    </div>
  );
}

export default withStyles(styles)(MobileLogo);
